export const CREATOR_PAGE_SELECTION_EVENT = "creator-page-selection-change";
let activeCreatorPageId: string | null = null;

export function setActiveCreatorPageId(
  pageId?: string | null,
  emitEvent = false
) {
  if (!pageId) {
    activeCreatorPageId = null;
    if (emitEvent) {
      window.dispatchEvent(
        new CustomEvent(CREATOR_PAGE_SELECTION_EVENT, {
          detail: { pageId: null },
        })
      );
    }
    return;
  }

  activeCreatorPageId = pageId;
  if (emitEvent) {
    window.dispatchEvent(
      new CustomEvent(CREATOR_PAGE_SELECTION_EVENT, {
        detail: { pageId },
      })
    );
  }
}

export function getActiveCreatorPageId() {
  return activeCreatorPageId;
}
